import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Send, UserPlus } from 'lucide-react';
import { NewCaseModal } from '../NewCaseModal';
import { ErfassungEinladenDialog } from './ErfassungEinladenDialog';

const STIL = {
  dunkel: ['bg-[#b8893d] text-white hover:bg-[#a5782f] border-[#b8893d]', 'bg-white/5 text-white border-white/30 hover:bg-white/10'],
  hell: ['bg-[#b8893d] text-white hover:bg-[#a5782f] border-[#b8893d]', 'bg-white text-[#1B3A5C] border-gray-200 hover:border-[#b8893d]'],
};

export const MandantAnlegenAktionen = ({ ton = 'hell' }) => {
  const navigate = useNavigate();
  const [dialog, setDialog] = useState(null);
  const [primaer, sekundaer] = STIL[ton];
  const btn = 'inline-flex items-center gap-2 h-10 px-4 text-sm rounded-[10px] border transition-colors duration-200';
  return (
    <div className="flex flex-wrap gap-2" data-testid="mandant-anlegen-aktionen">
      <button type="button" onClick={() => setDialog('einladen')} className={`${btn} ${sekundaer}`} data-testid="mandant-einladen-btn"><Send className="w-4 h-4" />Zur Registrierung einladen</button>
      <button type="button" onClick={() => setDialog('anlegen')} className={`${btn} ${primaer}`} data-testid="mandant-anlegen-btn"><UserPlus className="w-4 h-4" />Mandant anlegen</button>
      {dialog === 'einladen' && <ErfassungEinladenDialog onClose={() => setDialog(null)} />}
      {dialog === 'anlegen' && <NewCaseModal neuerMandant onClose={() => setDialog(null)} onCreated={(c) => { setDialog(null); navigate(c.ohne_akte ? `/kanzlei/mandanten/${c.mandanten_nr}` : `/team-portal/${c.id}`); }} />}
    </div>
  );
};
